import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { TituloReceberDashboardComponent } from './titulo-receber-dashboard.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberDashboardComponent
    ],
    exports: [
        TituloReceberDashboardComponent
    ]
})
export class TituloReceberDashboardModule { }
